import { useTheme } from '@mui/material';
import { useIsMobile } from '@side/pantry';
import NextLink, { type LinkProps } from 'next/link';
import { forwardRef, type Ref } from 'react';

export const StyledNextLink = forwardRef(
  (props: LinkProps, ref: Ref<HTMLAnchorElement>) => {
    const isMobile = useIsMobile('md');
    const { spacing } = useTheme();

    return (
      <NextLink
        style={{ marginTop: isMobile ? spacing(3) : spacing(4) }}
        ref={ref}
        {...props}
      />
    );
  },
);

StyledNextLink.displayName = 'StyledNextLink';
